import styles from "./NotificationConfigPage.module.scss"
import { NotificationConfigPageProps } from "./NotificationConfigPage.types"

function Wrapper(props: NotificationConfigPageProps) {
    const { children } = props

    return <div className={styles.wrapper}>{children}</div>
}

function Controls(props: NotificationConfigPageProps) {
    const { children } = props

    return <div className={styles.controls}>{children}</div>
}

export default { Controls, Wrapper }
